import { Calendar } from '@carbon/react/icons';
import { getError } from 'atoms/form-atoms';
import { Column, Row, Layer } from '@carbon/react';
import { DatePicker } from 'components/date-picker';

import { FormRow, FormSection } from 'components/forms';
import { getDateString } from 'utils/dates';
import { useAtom, useAtomValue } from 'jotai';
import { nonCourthouseFormAtom } from './atoms';

const NonCourthouseDates = () => {
  const form = useAtomValue(nonCourthouseFormAtom);
  const [field, setField] = useAtom(form.effectiveDate);
  return (
    <FormSection title="Document Dates" iconComponent={<Calendar size={32} />}>
      <FormRow>
        <Row>
          <Column>
            <Layer>
              <DatePicker
                id="effective-date"
                labelText="Effective Date"
                value={field.value ?? undefined}
                onChange={(date) => {
                  setField(date[0] ? getDateString(date[0]) : null);
                }}
                invalid={!field.isValid}
                invalidText={getError(field)}
              />
            </Layer>
          </Column>
        </Row>
      </FormRow>
    </FormSection>
  );
};

export { NonCourthouseDates };
